module.exports = __webpack_public_path__ + "static/media/service4-img.b453617c.png";